import App from './App.vue'
import { createApp } from 'vue'
import { build } from './router'
/**
 * @import { ComponentProps } from './propTypes.js'
 */
const rootEl = document.getElementById('app')
const dataset = rootEl?.dataset
const inputErrors = JSON.parse(dataset?.inputErrors ?? 'null')
/** @type {ComponentProps} */
const rootProps = {
  inputErrors: inputErrors,
}
const { router } = build()

createApp(App, rootProps).use(router).mount('#app')
